import { useMarket } from "@app/_context";
import { Heading } from "@components/ui";

import { isAdyenCheckoutEnabled } from "@/config/checkout";

import { useCheckoutContext } from "../Checkout.hooks";
import { checkoutStore } from "../Checkout.store";
import CheckoutTextInput from "../CheckoutTextInput";
import CheckoutCountrySelect from "./CheckoutCountrySelect";

export default function CheckoutDeliveryAddressFields() {
  const marketConfig = useMarket().state.market;
  const { dictionary } = useCheckoutContext();
  const hasSeparateDeliveryAddress = checkoutStore(
    (state) => state.hasSeparateDeliveryAddress,
  );

  if (
    isAdyenCheckoutEnabled({ marketConfig }) === false ||
    hasSeparateDeliveryAddress === false
  ) {
    return null;
  }

  return (
    <>
      {dictionary.checkoutAddressHeading && (
        <Heading size={5} className="col-span-2 my-4 text-center">
          {dictionary.checkoutDeliveryAddressHeading}
        </Heading>
      )}
      <CheckoutTextInput
        className="max-lg:col-span-2"
        label={dictionary.firstName}
        name="deliveryFirstName"
        type="text"
      />
      <CheckoutTextInput
        className="max-lg:col-span-2"
        label={dictionary.lastName}
        name="deliveryLastName"
        type="text"
      />
      <CheckoutTextInput
        className="max-lg:col-span-2"
        label={dictionary.street}
        name="deliveryLine1"
        type="text"
      />
      <CheckoutTextInput
        className="max-lg:col-span-2"
        label={dictionary.zipCode}
        name="deliveryZipCode"
        type="text"
      />
      <CheckoutTextInput
        className="max-lg:col-span-2"
        label={dictionary.city}
        name="deliveryCity"
        type="text"
      />
      <CheckoutCountrySelect
        name="deliveryCountry"
        label={dictionary.country}
      />
    </>
  );
}
